import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import debounce from 'lodash.debounce';
import styled from 'src/ui/library/styled';
import TextField from "src/ui/library/TextField";
import { MenuItem } from '@mui/material';

const styles = theme => ({
  clearIndicator: {
    display: 'none',
  },
  listWrap: {
    whiteSpace: 'normal',
  },
  root: {
    display: 'contents'
  }
});

class AutocompleteBase extends React.Component {
  constructor(props) {
    super(props);
    const initialValue = props.loadOptions && Array.isArray(props.loadOptions) && props.loadOptions.find(option => option.value === props.value);
    this.state = {
      inputVal: props.value!==0 && initialValue ? initialValue.label : '',
      isOpen: false,
      options: props.loadOptions || [],
      valueObject: initialValue ? initialValue : null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)){
      const initialValue = this.props.loadOptions && this.props.loadOptions.find(option => option.value === this.props.value);
      this.setState({
        inputVal: this.props.value!==0 && initialValue ? initialValue.label : '',
        options: this.props.loadOptions || [],
        valueObject: initialValue ? initialValue : null,
      });
    }
  }

  handleChange = (event, newValue) => {
    console.log("handleChange",event)
    if(newValue){
    this.setState({ valueObject: newValue }, () => {
      let selectedValue = newValue
      if (this.props.onChange) {
        this.props.onChange({
          target: {
            name: this.props.name || null,
            id: this.props.id || null,
            ...selectedValue,
          },
        });
      }
    });
    this.inputRef.focus();
  }
  };

  handleInputChange = (e, newvalue, reason) => {
    if (reason === "input") {
      let inputValue = newvalue
      this.setState({ inputVal: inputValue })
    }
  }

  setInputRef = el => {
    this.inputRef = el;
  };

  render() {
    const { disabled, classes, noResultsText, textfieldstyle, textfieldvariant, label, required, isExtendedLabel, isQuestionnaireControl } = this.props;
    const { options, valueObject, inputVal, isOpen } = this.state;
    const comboBoxInstruction = `${label}${required ? ' required' : ''} editable combo-box use the arrow keys or type the answer`;

    return (
      <Autocomplete
        openOnFocus={this.props.openOnFocus === false ? this.props.openOnFocus : true}
        open={this.state.isOpen}
        onOpen={() => this.setState({ isOpen: true })}
        onClose={() => this.setState({ isOpen: false, inputVal: this.state.valueObject && this.state.valueObject !== null ? this.state.valueObject.label : '' })}
        inputValue={inputVal}
        onInputChange={this.handleInputChange}
        defaultValue={null}
        id={this.props.id}
        disabled={disabled}
        noOptionsText={noResultsText}
        options={options}
        getOptionLabel={(option) => option.label}
        value={valueObject}
        onChange={this.handleChange}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          
          return <MenuItem classes={{root:classes.listWrap}} key={option.value}
          {...optionProps} tabIndex={0} >
            {option.label}
          </MenuItem>
          
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              removedisablefocus={this.props.removedisablefocus || false}
              inputRef={this.setInputRef}
              hasError={this.props.hasError}
              errorText={this.props.errorText}
              variantType={textfieldvariant}
              styleType={textfieldstyle}
              labelOutside={this.props.outSideLabel === false ? this.props.outSideLabel :true}
              // labelOutside={false}
              // value={params.inputProps && params.inputProps.value}
              autoCompletForceShrink={params.inputProps && params.inputProps.value.length >0 ? true : false}
              label={label}
              required={this.props.required}
              isQuestionnaireControl={isQuestionnaireControl}
              inputProps={{
                ...params.inputProps,
                role: 'combobox',
                ...(isExtendedLabel ? {
                  'aria-autocomplete': 'list',
                  'aria-haspopup': 'listbox',
                  'aria-expanded': isOpen,
                  'aria-label': comboBoxInstruction,
                } : {
                  'aria-expanded': false,
                }),
                onBlur: (e) => {
                  //remove below comment after final testing
                  console.log(e, document.activeElement)
                  
                  this.setState({ isOpen: false, inputVal: this.state.valueObject && this.state.valueObject !== null ? valueObject.label : '' });
                  setTimeout(() => {
                    params.inputProps && params.inputProps.onBlur(e);
                  }, 0)
                  
                },
              }}
            />
          )
        }}
        classes={{
          clearIndicator: classes.clearIndicator,
          root: classes.root
        }}
      />
    );
  }
}

export { AutocompleteBase };
export default styled(AutocompleteBase)(styles);